module.exports = __webpack_public_path__ + "img/乌镇隆源路街区.7d8a8c9a.jpg";